import { _List } from "../lists/types.js";
import { getValueForUICultureBinder } from "./funcs.js";
_List.prototype.titleResource = getValueForUICultureBinder("titleResource");
_List.prototype.descriptionResource = getValueForUICultureBinder("descriptionResource");
//# sourceMappingURL=list.js.map